export default "__VITE_ASSET__Ctvlf220__"